__turbopack_context__.v({
  "actionWrap": "ServiceDetails-module__oRU_GG__actionWrap",
  "btnPrimary": "ServiceDetails-module__oRU_GG__btnPrimary",
  "btnSecondary": "ServiceDetails-module__oRU_GG__btnSecondary",
  "checkIcon": "ServiceDetails-module__oRU_GG__checkIcon",
  "contentBox": "ServiceDetails-module__oRU_GG__contentBox",
  "contentColumn": "ServiceDetails-module__oRU_GG__contentColumn",
  "description": "ServiceDetails-module__oRU_GG__description",
  "featureItem": "ServiceDetails-module__oRU_GG__featureItem",
  "featureList": "ServiceDetails-module__oRU_GG__featureList",
  "featuresSection": "ServiceDetails-module__oRU_GG__featuresSection",
  "featuresTitle": "ServiceDetails-module__oRU_GG__featuresTitle",
  "idealForBox": "ServiceDetails-module__oRU_GG__idealForBox",
  "idealLabel": "ServiceDetails-module__oRU_GG__idealLabel",
  "idealText": "ServiceDetails-module__oRU_GG__idealText",
  "image": "ServiceDetails-module__oRU_GG__image",
  "imageColumn": "ServiceDetails-module__oRU_GG__imageColumn",
  "imageOverlay": "ServiceDetails-module__oRU_GG__imageOverlay",
  "imageWrapper": "ServiceDetails-module__oRU_GG__imageWrapper",
  "orderLast": "ServiceDetails-module__oRU_GG__orderLast",
  "serviceDetails": "ServiceDetails-module__oRU_GG__serviceDetails",
  "serviceRow": "ServiceDetails-module__oRU_GG__serviceRow",
  "tagline": "ServiceDetails-module__oRU_GG__tagline",
  "title": "ServiceDetails-module__oRU_GG__title",
  "wrapper": "ServiceDetails-module__oRU_GG__wrapper",
});
